import React from 'react';

import styles from './index.css';

export function Dot({ className, color, ...props }) {
    return (
        <div {...props} className={`${styles.root} ${className || ''}`}>
            <div className={styles.dot} style={{ background: color }}></div>
        </div>
    );
}
